/* Stratus content pages: stockist region chips (assets/st-content-a-stockists.js). No library.
 *
 * Contract: [data-st-stockists] holds [data-st-stockists-chips] (a group of buttons, each with data-st-region, empty for
 * "All") and the lists, one [data-st-group="<region>"] per region. A chip shows its region's group and hides the
 * others; "All" shows every one. The chips arrive hidden: without this script the whole list stays readable.
 * Safe to load more than once and on section reload in the theme editor (each block is wired once).
 */
(function () {
  function wire(root) {
    if (root.getAttribute('data-st-stockists-ready')) return;
    var chips = root.querySelector('[data-st-stockists-chips]');
    if (!chips) return;
    root.setAttribute('data-st-stockists-ready', 'true');
    var buttons = chips.querySelectorAll('button[data-st-region]');
    var groups = root.querySelectorAll('[data-st-group]');

    function select(region) {
      Array.prototype.forEach.call(buttons, function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-st-region') === region ? 'true' : 'false');
      });
      Array.prototype.forEach.call(groups, function (group) {
        group.hidden = region !== '' && group.getAttribute('data-st-group') !== region;
      });
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        select(button.getAttribute('data-st-region') || '');
      });
    });
    chips.hidden = false;
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-st-stockists]'), wire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
